<template>
    <v-layout column>
        <span class="title text-xs-left mb-2">WordPress LearnDash Upload</span>
        <v-divider class="grey"></v-divider>
        <br>
        <v-dialog v-model="uploadDialog" max-width="350" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    <!-- <v-icon medium color="warning">warning</v-icon> -->
                    Upload CSV File
                </v-card-title>
                <v-card-text class="text-xs-left">
                    <v-text-field prepend-icon="attach_file" id="file" single-line @click="getFile()" v-model="file" label="Upload File" required  ref="fileTextField" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"></v-text-field>
                    <v-text-field v-model="file" type="file" id="get_file" class="get_file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"></v-text-field>

                    <v-radio-group v-model="uploadType" required row>
                        <v-radio
                            label="Courses"
                            value="course"
                        ></v-radio>
                        <v-radio
                            label="Quizes"
                            value="quiz"
                        ></v-radio>
                        <v-radio
                            label="Users"
                            value="user"
                        ></v-radio>
                    </v-radio-group>
                </v-card-text>
                <v-card-actions>
                    <v-flex layout row wrap>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="error" block dark flat="flat" @click="uploadDialog = false">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="primary" block dark flat="flat" @click="upload()">Submit</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card>
            <v-toolbar flat dense class="primary" dark>
                <!--<v-text-field xs6 v-model="searchText" prepend-icon="search" label="Search" color="white" single-line clearable hide-details></v-text-field>-->
                <!--<v-spacer></v-spacer>-->
                <!--<v-btn  v-show="$store.state.auth.user.role!=4" dark class="primary darken-2" flat @click="createClassroomDialog = true"><v-icon class="pr-3">add</v-icon>Create Classroom</v-btn>-->
                <v-btn dark class="primary darken-2" flat  @click="uploadDialog = true"><v-icon class="pr-3">add</v-icon>Upload File</v-btn>
                <!--<v-btn color="primary" dark class="mb-2" icon @click="update()"><v-icon>refresh</v-icon></v-btn>-->
            </v-toolbar>

            <!--<v-data-table v-if="$store.state.classrooms.student.headers" :headers="$store.state.classrooms.student.headers"-->
                          <!--:items="allItems" :loading="loading" :search="searchText" class="elevation-2" :total-items="total"-->
                          <!--:rows-per-page-items="rows" :pagination.sync="pagination">-->
                <!--<v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>-->
                <!--<template slot="items" slot-scope="props">-->
                    <!--<tr @click="highlightDevice = props.item" :class="{'grey lighten-3':highlightDevice == props.item}">-->
                        <!--<td v-for="(header, index) in $store.state.classrooms.student.headers" :key="index" :class="'text-xs-'+header.align">-->
                            <!--<span v-if="header.value != 'actions'">{{ props.item[header.value] }}</span>-->
                            <!--<span v-else v-show="$store.state.auth.user.role!=4">-->
                <!--<v-btn icon class="grey lighten-4" @click="edit(props.item)">-->
                  <!--<v-icon color="primary">edit</v-icon>-->
                <!--</v-btn>-->
                                <!--&lt;!&ndash;<v-btn icon class="grey lighten-4" @click="deletePrompt(props.item)">&ndash;&gt;-->
                                <!--&lt;!&ndash;<v-icon color="accent">delete</v-icon>&ndash;&gt;-->
                                <!--&lt;!&ndash;</v-btn>&ndash;&gt;-->
              <!--</span>-->
                        <!--</td>-->
                    <!--</tr>-->
                <!--</template>-->

            <!--</v-data-table>-->
        </v-card>
    </v-layout>
</template>

<script>
    import WordPressService from "@/services/WordPressService";

    export default {
        name: "WordPressUpload",
        components: {},
        data() {
            return {
                searchText: null,
                highlightDevice: null,
                loading: false,
                loadingTime: 1000,
                deleteDialog: false,
                createClassroomDialog: false,
                selectedId: null,
                allItems:[],
                rows:[10,20,50,150,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
                pagination: {},
                total: 0,
                lastPage: 1,
                file: "",
                uploadDialog: false,
                uploadType: null,
                form: {
                    name: null,
                    description: null,
                    alias: null,
                },
            };
        },
        watch: {
            pagination: {
                handler () {
                },
                deep: true
            },
            async searchText(){
                try {
                    var color = "info";
                    // this.loading=true;
                    // console.log('Search Watch');
                    // console.log(this.searchText);
                    // const response = await InteractionService.getAll("", "", this.pagination.rowsPerPage, this.searchText);
                    // console.log(response);
                    // if (response.data.code > 200) {
                    //     color = "warning";
                    // } else if (response.data.result == 2000) {
                    //     this.$store.dispatch("setInteractions", response.data.data);
                    //     this.allItems=response.data.data;
                    //     this.total = response.data.total;
                    //     // this.convertDate()
                    // }
                    // this.loading = false;
                    // this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
                } catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occurred", color: "error", x: "left", timeout: 3000});
                }
            }
        },
        mounted() {
        },
        methods: {
            async upload(){
                try{
                    var color = "warning";
                    var formData = new FormData();

                    // this.file=document.getElementById('get_file').files[0];
                    formData.append('file', document.getElementById('get_file').files[0]);
                    formData.append('uploadType', this.uploadType);
                    if(document.getElementById('get_file').files[0])
                        this.$store.dispatch('setSnackbar', {show: true, text: "Uploading", color: color, x:'right', timeout: 10000});
                    const response = await WordPressService.upload(formData);
                    console.log("formdata: ", formData);
                    console.log("upload type", this.uploadType);
                    // // console.log(response)
                    // if(response.data.code > 403){
                    //     color = "warning"
                    // }else if(response.data.result == 2000){
                    //     this.file= "";
                    // }
                    // this.methodDialog = false;
                    // this.uploadDialog = false;
                    // this.getAll();
                    color = "info";
                    this.uploadDialog = false;
                    this.$store.dispatch('setSnackbar', {show: true, text: response.data.message, color: color, x:'right', timeout: 7000})
                }catch(err){
                    console.log(err);
                    this.uploadDialog = false;
                    this.$store.dispatch('setSnackbar', {show: true, text: "Upload error occured", color: "error", x:'right', timeout: 5000})
                }
            }
        }
    };
</script>

<style scoped>

</style>